import { get } from '@/api/general';

export default {
    list: (params) => get('conditions', params),
};
